// React
import { useEffect, useState } from "react"

// Types
import type { SelectOptionType, SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

export function useFileList(): {
  data: SelectOptionType[]
  isLoading: boolean
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get(
      "/import_coa/filename"
    ).then((res: SuccessFetch<{
      payload: { file_name: string }[]
    }>) => {
      assignData(res.data.payload.map(item => item.file_name))
    }).catch(() => {
      assignData([])
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData([])
      setLoading(true)
    }
    
    // eslint-disable-next-line
  }, [])

  // Functions
  const assignData = (value: string[]): void => {
    // Vars
    const data: SelectOptionType[] = value.map(item => ({
      label: item,
      value: item
    }))

    setData([
      {
        label: "All",
        value: "All"
      },
      ...data
    ])
  }

  return { data, isLoading }
}